import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
    {
        id: 2,
        label: 'reserve_facility',
        icon: 'ph-trophy',
        link: '/app/facilities',
    },
    {
        id: 3,
        label: 'my_reserves',
        icon: 'ph-calendar-blank',
        link: '/app/reservations',
    },
    {
        id: 4,
        label: 'payments',
        icon: 'ph-receipt',
        link: '/app/invoices',
    },
    {
        id: 7,
        label: 'profile',
        icon: 'ph-user',
        link: '/app/profile-view',
    },
]